import { Box, Button } from "@mui/material";
import type { FC } from "react";

type Props = {
  readonly onClick: () => Promise<void>;
};

export const RiskInsuranceEmptyState: FC<Props> = ({ onClick }) => {
  return (
    <Box
      sx={{
        height: 60,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button variant="contained" onClick={onClick}>
        Doporučit krytá rizika
      </Button>
    </Box>
  );
};
